import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

const PublicRoute = ({ children }) => {
  const { token, profile } = useSelector((state) => state.login);
  let location = useLocation();
  const targetRoute = location?.state?.pre;

  return !token ? (
    <div>{children}</div>
  ) : profile?.is_complete ? (
    <Navigate to={targetRoute ? targetRoute : "/"} />
  ) : (
    <Navigate to="/profile" state={{ pre: targetRoute }} />
  );
};

export default PublicRoute;
